import { useQuery } from "@tanstack/react-query";

import { getPacingMetrics } from "../../../../api/getPacingMetrics";
import { useSalesContext } from "../../../../sales-context/SalesContext";

export const usePacingMetrics = () => {
    const { apiClients } = useSalesContext();
    const { data, isLoading, isError } = useQuery({
        queryKey: ["pacing-metrics"],
        queryFn: async () => getPacingMetrics(apiClients.gamification),
        refetchOnWindowFocus: false,
        retry: 0,
        gcTime: 0,
    });
    return { data, isLoading, isError };
};
